/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";

import SelectInput2 from "../../component/input/SelectInput2";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";

const TopInput = ({
  setGetByLocationId,
  getByLocationId,
  currentUser,
  locations
}) => {
  return (
    <div className="row">
      <ReactTooltip
        id="getByLocationId"
        place="top"
        effect="solid"
        type="info"
      >
        Select Location to Get the Users
      </ReactTooltip>
      <div className="col-xl-4">
        <SelectInput2
          data-tip
          name="getByLocationId"
          isLabeled={true}
          onChange={setGetByLocationId}
          icon="mdi mdi-map-marker-radius"
          data-for="getByLocationId"
          label="Select Location"
          value={getByLocationId}
          placeholder="Select Location"
        >
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(locations)
            : renderAccessLocation2(
                locationRender(currentUser, false)
              )}
        </SelectInput2>
      </div>
    </div>
  );
};

TopInput.propTypes = {
  getByLocationId: PropTypes.string.isRequired,
  setGetByLocationId: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default TopInput;
